const testimonials = [
  {
    id: 1,
    name: "Burt Rutan",
    title: "Creator of",
    org: "Scaled Composites",
    desc: "Testing leads to failure, and failure leads to understanding.",
  },
  {
    id: 2,
    name: "Andrew Hunt",
    title: "Writer",
    org: "The Pragmatic Programer",
    desc: "In some ways, programing is like painting. You start with a blank canvas and certain basic raw materials. You use a combination of science, art, and craft to determine what to do with them.",
  },
  {
    id: 3,
    name: "Chris Pine",
    title: "Writer",
    org: "Learn to Program",
    desc: "Programing isn't about what you know; it's about what you can figure out.",
  },
];

export default testimonials;
